<template>
    <section v-if="product.options.length" class="app-product-options-view container-fluid">
    </section>
</template>

<script>
export default {
    name: 'ProductOptions',
    computed: {
        product: (vm) => vm.$store.getters.productMapped,
        productPathSegment: (vm) => vm.$store.state.productPathSegment,
        currentStep: (vm) => vm.$store.state.currentStep
    },
    methods: {
        goForward (replace) {
            if (this.currentStep < 3) {
                this.$store.commit('setCurrentStep', 3)
            }

            this.$router[replace === true ? 'replace' : 'push']({
                name: 'steps',
                hash: '#personal-data',
                params: {
                    productPathSegment: this.productPathSegment
                }
            })
        }
    },
    watch: {
        $route () {
            if (this.$route.params && this.$route.hash === '#product-options' && !this.product.options.length) {
                this.goForward(true)
            }
        }
    },
    created () {
        if (!this.product.options.length) this.goForward(true)
    }
}
</script>

<style scoped>
    .app-product-options-view {
        position: relative;
        max-width: 1200px;
        padding-bottom: 20px;
    }
    .app-product-options-view__main {
        margin-bottom: 2em;
        padding: 15px;
        background-color: #fff;
        text-align: center;
    }

    @media ( min-width: 576px ) {
        .app-product-options-view__main {
            padding: 30px;
        }
    }
    @media ( min-width: 992px ) {
        .app-product-options-view__main {
            padding: 60px;
        }
    }
</style>
